import { FlyerCount, FlyerPaper, FlyerSide } from '~/tenants/bre/performable/print/flyers/BreFlyersConfig';
import { BrePrintSpeed } from '~/tenants/bre/data';

type CountMap = Record<FlyerCount, string>;

type PaperMap = Record<FlyerPaper, CountMap>;

type SideMap = Record<FlyerSide, Partial<PaperMap>>;

type NeedByMap = Record<BrePrintSpeed, Partial<SideMap>>;

export const BreFlyersRate: NeedByMap = {
  [BrePrintSpeed.STANDARD]: {
    1: {
      low_gloss: {
        50: '175',
        100: '195',
        150: '225',
        200: '255',
      },
      heavy_gloss: {
        50: '200',
        100: '235',
        150: '275',
        200: '310',
      },
    },
    2: {
      low_gloss: {
        50: '185',
        100: '220',
        150: '265',
        200: '300',
      },
      heavy_gloss: {
        50: '210',
        100: '260',
        150: '310',
        200: '365',
      },
      super_heavy_gloss: {
        50: '220',
        100: '270',
        150: '330',
        200: '380',
      },
    },
    4: {
      heavy_gloss: {
        50: '300',
        100: '430',
        150: '585',
        200: '725',
      },
      super_heavy_gloss: {
        50: '340',
        100: '460',
        150: '605',
        200: '755',
      },
    },
  },
  [BrePrintSpeed.RUSH]: {
    1: {
      low_gloss: {
        50: '195',
        100: '220',
        150: '250',
        200: '265',
      },
      heavy_gloss: {
        50: '225',
        100: '255',
        150: '295',
        200: '325',
      },
    },
    2: {
      low_gloss: {
        50: '210',
        100: '245',
        150: '280',
        200: '325',
      },
      heavy_gloss: {
        50: '235',
        100: '280',
        150: '335',
        200: '385',
      },
      super_heavy_gloss: {
        50: '250',
        100: '295',
        150: '360',
        200: '415',
      },
    },
    4: {
      heavy_gloss: {
        50: '350',
        100: '495',
        150: '655',
        200: '805',
      },
      super_heavy_gloss: {
        50: '375',
        100: '500',
        150: '645',
        200: '820',
      },
    },
  },
};

export const BreFlyersPay: NeedByMap = {
  [BrePrintSpeed.STANDARD]: {
    1: {
      low_gloss: {
        50: '150',
        100: '170',
        150: '195',
        200: '220',
      },
      heavy_gloss: {
        50: '175',
        100: '205',
        150: '240',
        200: '270',
      },
    },
    2: {
      low_gloss: {
        50: '160',
        100: '190',
        150: '230',
        200: '260',
      },
      heavy_gloss: {
        50: '180',
        100: '225',
        150: '270',
        200: '315',
      },
      super_heavy_gloss: {
        50: '190',
        100: '235',
        150: '285',
        200: '330',
      },
    },
    4: {
      heavy_gloss: {
        50: '260',
        100: '375',
        150: '510',
        200: '630',
      },
      super_heavy_gloss: {
        50: '295',
        100: '400',
        150: '525',
        200: '655',
      },
    },
  },
  [BrePrintSpeed.RUSH]: {
    1: {
      low_gloss: {
        50: '170',
        100: '190',
        150: '215',
        200: '230',
      },
      heavy_gloss: {
        50: '195',
        100: '220',
        150: '255',
        200: '285',
      },
    },
    2: {
      low_gloss: {
        50: '180',
        100: '210',
        150: '240',
        200: '280',
      },
      heavy_gloss: {
        50: '205',
        100: '240',
        150: '290',
        200: '335',
      },
      super_heavy_gloss: {
        50: '215',
        100: '255',
        150: '310',
        200: '360',
      },
    },
    4: {
      heavy_gloss: {
        50: '305',
        100: '430',
        150: '570',
        200: '700',
      },
      super_heavy_gloss: {
        50: '325',
        100: '435',
        150: '560',
        200: '710',
      },
    },
  },
};
